import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import Terms from "../components/Terms";
import AuthHeader from "../components/AuthHeader";
import UrlAnalysisPageLayout from "./components/url/UrlAnalysisPageLayout";
import { ReportLoadStatus } from "../store";
import { UrlScanResponse } from "../models/url-analysis-data-structures";
import { transformUrlScanResult } from "../logic/url-scan-data-processing";

export default function UrlAnalysisPage() {
  const location = useLocation();
  // Try to get the scan response from location.state or sessionStorage
  let analysisJson: UrlScanResponse | undefined =
    location.state && location.state.analysisJson;

  // If we have analysisJson, save it to sessionStorage
  if (analysisJson) {
    try {
      sessionStorage.setItem("urlAnalysisJson", JSON.stringify(analysisJson));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("Could not save analysisJson to sessionStorage", e);
    }
  } else {
    // Try to load from sessionStorage
    const stored = sessionStorage.getItem("urlAnalysisJson");
    if (stored) {
      try {
        analysisJson = JSON.parse(stored);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("Could not parse analysisJson from sessionStorage", e);
      }
    }
  }

  const isValidResponse =
    !!analysisJson && Array.isArray(analysisJson.resources);

  const viewModel = useMemo(
    () => (isValidResponse ? transformUrlScanResult(analysisJson!) : null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [analysisJson, isValidResponse],
  );

  if (!isValidResponse) {
    // Show a friendly error if no data is present
    return (
      <div className="app">
        <Terms />
        <div style={{ position: "fixed", top: 10, right: 10, zIndex: 9999 }}>
          <AuthHeader layout="fixed" />
        </div>
        <div
          style={{
            maxWidth: 600,
            margin: "100px auto",
            padding: 32,
            background: "#fff3f3",
            borderRadius: 12,
            textAlign: "center",
            color: "#b71c1c",
          }}
        >
          <h2>Analysis Not Available</h2>
          <p>
            The analysis could not be loaded. This may be due to a timeout or
            network error.
            <br />
            Please try scanning the URL again.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <Terms />
      <div style={{ position: "fixed", top: 10, right: 10, zIndex: 9999 }}>
        <AuthHeader layout="fixed" />
      </div>
      <UrlAnalysisPageLayout
        scanId={viewModel?.scanId || "url-analysis"}
        viewModel={viewModel}
        rawResponse={analysisJson ?? null}
        loadStatus={ReportLoadStatus.REPORT_LOADED}
        errorMsg={null}
      />
    </div>
  );
}
